import React, { forwardRef, useImperativeHandle, useState } from "react";
import DataTable from "react-data-table-component";
import CustomPagination from "./CustomPagination";


const DataTable_ = forwardRef(
  (
    {
      columns = [],
      data = [],
      pagination = true,
      customStyles = {},
      handlefetchData = () => {},
      totalCount = 0,
      // handlefetchData = () => {},
      search = null,
      tableMinHeight = 50,
      initialPage = 1,
      initialPerPage = 10,
      ...DataTableProps
    },
    ref
  ) => {
    const customStyles_ = {
      tableWrapper: {
        style: {
          minHeight: `${tableMinHeight}vh`, // Set your minimum height here
        },
      },
      headCells: {
        style: {
          backgroundColor: "#F7F7F7", // Custom header background color
          color: "black", // Custom header text color
          fontSize: "1.4rem", // Custom font size for header
        },
      },
      cells: {
        style: {
          fontSize: "12px", // Custom font size for cells
        },
      },
      table: {
        style: {
          border: "1px solid #DBDBDB", // Border color for the entire table
          flex: 1,
          width: "100%",
          marginTop: "20px",
        },
      },
      ...customStyles,
    };

    // Custom "No Data" message
    const noDataMessage = (
      <div style={{ padding: "20px", textAlign: "center", color: "#black" }}>
        No Data.
      </div>
    );

    const [pageOptions, setPageOptions] = useState([10, 20, 30]);

    const [perPage, setPerPage] = useState(initialPerPage);
    const [currentPage, setCurrentPage] = useState(initialPage);

    const [limit, setLimit] = useState(initialPerPage);

    const [noOfRowsPerPage, setNoOfRowsPerPage] = useState(initialPerPage);

    useImperativeHandle(ref, () => ({
      resetFields() {
        setPerPage(10);
        setCurrentPage(1);
        setPageOptions([10, 20, 30]);
        setLimit(10);
        setNoOfRowsPerPage(10);
      },
    }));

    // const resetFields=()=>{
    //   setPerPage(10)
    //   setLimit(10)
    //   setNoOfRowsPerPage(10)
    // }

    // useEffect(()=>{

    //   if(search){
    //     resetFields()
    //   }
    // },[search])

    const handlePageChange = (page) => {
      fetchData(page, perPage);
      setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
      setPerPage(newPerPage);
      setNoOfRowsPerPage(newPerPage);
      handlefetchData({ limit: newPerPage, offset: 0 });
      setLimit(newPerPage);
    };

    const fetchData = async (page, per_page) => {
      const offset = (page - 1) * per_page;

      handlefetchData({ limit: per_page, offset });
    };

    const TotalPages = Math.ceil(totalCount / perPage);

    return (
      <DataTable
        columns={columns}
        data={[...data]}
        pagination={pagination}
        customStyles={customStyles_} // Applying custom styles
        noDataComponent={noDataMessage} // Custom "No Data" component
        {...DataTableProps}
        responsive={true}
        paginationServer
        paginationPerPage={noOfRowsPerPage}
        //// Total number of rows
        paginationTotalRows={totalCount}
        //handler for pagination arrow change
        onChangePage={handlePageChange}
        // drop down pagination
        paginationRowsPerPageOptions={pageOptions}
        //handler for dropdown pagination change
        onChangeRowsPerPage={handlePerRowsChange}
        paginationComponent={() => (
          <CustomPagination
            currentPage={currentPage}
            rowsPerPage={perPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
          />
        )}
        // {...DataTableProps}
      />
    );
  }
);

export default React.memo(DataTable_);